/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2022
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class VisGestureHelperAPI
 * @hideconstructor
 * @classdesc helper API class that is used to handle the visualization gestures
 */
define([], () => {
	class VisGestureHelperAPI {

		/**
		 * @function VisGestureHelperAPI#resolveCoordinates
		 * @description Resolve the coordinates from the given event
		 * @param {object}  event - event object
		 * @return {object} containing the resolved x / y coordinates
		 */
		resolveCoordinates(/* event */) {}

		/**
		 * @function VisGestureHelperAPI#isSkipSelection
		 * @description Check if skip selection needed
		 * @return {boolean} true, skip selection, otherwise false
		 */
		isSkipSelection() {}

		/**
		 * @function VisGestureHelperAPI#setEventLocalProperty
		 * @description Set the event local property
		 * @param {object} event -	event object
		 * @param {string} name	 -	property name
		 * @param {string} value -	property value
		 */
		setEventLocalProperty(/* event, name, value */){}

		/**
		 * @function VisGestureHelperAPI#getTarget
		 * @description Get current event target
		 * @return {object} current event target
		 */
		getTarget(){}

		/**
		 * @function VisGestureHelperAPI#isItemsSelected
		 * @description Determines whether the given target items are currently selected
		 * @param {object[]}	items -	event target items
		 * @return true if the target items are selected, otherwise false
		 */
		isItemsSelected(/* items */) {}

		/**
		 * @function VisGestureHelperAPI#isItemsHighlighed
		 * @description Determines whether the given target items are currently highlighted
		 * @param {object[]} items	-	event target items
		 * @return true if the target items are highlighted, otherwise false
		 */
		isItemsHighlighed(/*items*/) {}

		/**
		 * @function VisGestureHelperAPI#handleHighlights
		 * @description Handle hightlight event.
		 * @param {object[]} items -	event target items
		 * @param {boolean}  bAppend -	append items in this._lastHighlighted to items if true
		 */
		handleHighlights(/* items, bAppend */) {}

		/**
		 * @function VisGestureHelperAPI#handleSelections
		 * @description Handle selection event.
		 * Selection highlight the chart element upon click.
		 * @param {object} 		event -	event object
		 * @param {object[]} 	items -	event target items
		 * @param {boolean} 	[options.forceCtrlClick=false] - True forces a control + click selection
		 * @param {boolean} 	[options.forceRightClick=false] - True forces a right click selection
		 * @param {boolean} 	[options.isMultiSelect=false] - True indicates multiple datapoints are selected.
		 */
		handleSelections(/*event, items, options*/) {}

		/**
		 * @function VisGestureHelperAPI#clearAll
		 * @description Clear all selections from the selection controller
		 * @param {object} 	event -	event object
		 */
		clearAll(/* event */) {}

		/**
		 * @function VisGestureHelperAPI#getLassoController
		 * @description Get the current lasso controller
		 * @return {object} the current lasso controller
		 */
		getLassoController() {}

		/**
		 * @function VisGestureHelperAPI#getDataPayload
		 * @description Obtain the selection info object based on the event.
		 * @param {object}  event - event object
		 * @param {object}  infoClass - VisSelectionInfo (default) or VisTooltipInfo
		 * @return {object} data payload
		 */
		getDataPayload(/*items, infoClass*/) {}

		/**
		 * @function VisGestureHelperAPI#showSelectionInfo
		 * @description Display the selection tooltip.
		 * @param {object}  oSelectionObj - selection context
		 * @param {object}  event - event object
		 * @param {boolean} includeApplyFilter - include appy filter or not
		 * @param {boolean} noFilters - no filters applied
		 * @param {boolean} drillOnly - drill only
		 * @param {boolean} noDrillthrough - no drill through included
		 * @param {object}  options - other options
		 */
		showSelectionInfo(/*oSelectionObj, event, includeApplyFilter, noFilters, drillOnly, noDrillthrough, options */){}

		/**
		 * @function VisGestureHelperAPI#titleOrElementStyleActions
		 * @description Show the title or element style action toolbar for the given items
		 * @param {object}    event -	event object
		 * @param {object[]}  items -	event target items
		 */
		titleOrElementStyleActions(/*event, items*/) {}

		/**
		 * @function VisGestureHelperAPI#resolveItems
		 * @description Resolve the event target items to data item ids and tuples items
		 * @param  {object[]} items	- event target items
		 * @return {object[]} resolved array of object containing the data item ids and tuple items
		 */
		resolveItems(/*items*/) {}



	}

	return VisGestureHelperAPI;
});
